"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatMoney = exports.suffix = exports.isNumber = void 0;

var isNumber = function isNumber(value) {
  return !Number.isNaN(parseInt(value + '', 10));
};

exports.isNumber = isNumber;

var suffix = function suffix(value) {
  return isNumber(value) ? "-".concat(value) : '';
};

exports.suffix = suffix;

var formatMoney = function formatMoney(amount) {
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  });
  return formatter.format(amount);
};

exports.formatMoney = formatMoney;